import { ClipboardList, LayoutGrid, Layers, Store } from "lucide-react";

import { TEMA } from "@/components/canais/canais";
import { CaixaRegistradoraIcon, MesaIcon, MotoEntregaIcon, TotemIcon } from "@/components/icons/ModulosIcons";

// Abas do Relatório de Tempo e os módulos do mapa hora a hora. A `key` é a
// mesma do backend (api/v1/relatorio_tempo). Ícones iguais aos dos módulos no
// topo do painel (pedido do dono, 27/10/2026); Retirada usa a loja, como no
// Delivery ("Retirada no local"). Cores do TEMA de components/canais.
const com = (m) => {
  const tema = TEMA[m.cor] || TEMA.slate;
  return { ...m, tema, chip: tema.icone };
};

export const ABAS = [
  { key: "resumo", nome: "Resumo", Icon: LayoutGrid },
  com({ key: "mesas", nome: "Mesas", Icon: MesaIcon, cor: "blue" }),
  com({ key: "comandas", nome: "Comandas", Icon: ClipboardList, cor: "amber" }),
  com({ key: "delivery", nome: "Delivery", Icon: MotoEntregaIcon, cor: "orange" }),
  com({ key: "retirada", nome: "Retirada", Icon: Store, cor: "cyan" }),
  com({ key: "ifood", nome: "iFood", logo: "/logo-ifood.png", cor: "red" }),
];

export const MODULOS_MAPA = {
  ...Object.fromEntries(ABAS.filter((a) => a.key !== "resumo").map((a) => [a.key, a])),
  balcao: com({ key: "balcao", nome: "Balcão", Icon: CaixaRegistradoraIcon, cor: "purple" }),
  totem: com({ key: "totem", nome: "Totem", Icon: TotemIcon, cor: "violet" }),
  outros: com({ key: "outros", nome: "Outros", Icon: Layers, cor: "slate" }),
};

export const abaPorChave = (key) => ABAS.find((a) => a.key === key) || ABAS[0];
